<template>
    <transition name="right" mode="out-in">
        <keep-alive>
            <component :is="compName" v-bind.sync="editProps" />
        </keep-alive>
    </transition>
</template>
<script>
import TzggcxBrowse from "./TzggcxBrowse";
import TzggcxForm from "./TzggcxForm";
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "Tzggcx",
    components: { TzggcxBrowse, TzggcxForm },
    data() {
        return {
            editProps: {
                // 当前记录ID
                dataId: null,
                // 是否编辑状态
                showEdit: false,
                showForm: false,
                componentName: "TzggcxBrowse"
            }
        };
    },
    created() {
        if (this.getNoticeId) {
            this.editProps.componentName = "TzggcxForm";
            this.editProps.dataId = this.getNoticeId;
        }
    },
    // computed: {
    //     compName() {
    //         if (this.editProps.showForm === true) {
    //             return "TzggcxForm";
    //         } else {
    //             return "TzggcxBrowse";
    //         }
    //     }
    // }
    computed: {
        ...userMapGetters(["getNoticeId"]),
        compName() {
            return this.editProps.componentName;
        }
    }
};
</script>
